import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ApiService } from 'src/app/services/api/api.service';
import { Router } from '@angular/router';
import { finalize } from 'rxjs';
import * as alertify from 'alertifyjs';
import { ThemeService } from 'src/app/services/theme-service/theme.service';
import { SuccessModalComponent } from '../success-modal/success-modal.component';

interface Attribute {
  id: number;
  name: string;
}


interface Category {
  id: number;
  name: string;
}

@Component({
  selector: 'app-query-modal',
  templateUrl: './query-modal.component.html',
  styleUrls: ['./query-modal.component.css'],
  standalone: false
})
export class QueryModalComponent implements OnInit {
  form!: FormGroup;
  successMessage!: string;
  url!: string;
  isCurrentOfficerLoading: boolean = false;
  isSubmitting: boolean = false;
  isSubmitAttempted: boolean = false;
  // inspectors: string[] = [
  //   'Plumbing',
  //   'Electrical',
  //   'Lobby',
  //   'Guest Room',
  //   'Interiors',
  //   'Exteriors',
  // ];

  // // Static inspectors
  // attributes: string[] = [
  //   'Room Name',
  //   'Number of Rooms',
  //   'Room Type',
  //   'Attribute 3',
  //   'Amount Per Room',
  //   'Gate Fee',
  //   'Event Center',
  //   'Auditoriom',
  //   'Gym',
  // ];
  // Static attributes

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<QueryModalComponent>,
    @Inject(MAT_DIALOG_DATA) public initialData: any,
    public themeService: ThemeService,
    private apiService: ApiService,
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      comment: ['', Validators.required],
    });

    console.log('initialData', this.initialData)

  }

  get comment() {
    return this.form.get('comment');
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  openSuccessModal(successMessage: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form'],
      data: { successMessage },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.dialogRef.close({reload: true})
    });
  }

  approveOrQueryApplication(): void {
    if (this.form.valid) {
      this.isSubmitting = true;

      const comment = this.comment?.value;
    
      this.apiService
        .post(
          '/workflow/get-next-approving-officer',
          {
            comment: comment,
            workflowName: this.initialData.workflowName,
            entityId: this.initialData.entityId,
            type: 'QUERIED'
          }
        )
        .pipe(
          finalize(() => {
            this.isSubmitting = false;
          })
        )
        .subscribe(
          (response: any) => {
         

            

              this.openSuccessModal(response.message  || this.initialData.successMessage);
           
          },
          (error) => {
            console.error('Error performing action:', error);
          }
        );
    } else {
      console.error('Form is invalid');
    }

    this.isSubmitAttempted = true;
  }

  getErrorMessage(control: AbstractControl | null): string {
    // console.log('control', control);
    if (control && control.errors) {
      if (control.errors['required']) {
        return 'This field is required.';
      }
    }
    return '';
  }

  getSkeletonTheme() {}
}
